export default __webpack_public_path__ + "static/media/Unsar_Hameed.4b74a7a6.png";